import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../../lib/AppContext";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import {Link} from "@mui/material";
import Loading from "../common/Loading";
import {formatDateTime} from "../common/Utils";
import DataTable from "react-data-table-component";
import * as pagination from "../common/pagination";
import MDButton from "../../components/MDButton";
import {getCookie, setCookie} from "../common/appCookie";
import {CompanyContext} from "../../lib/CompanyContext";
import ActiveMember from "../common/ActiveMember";
import {searchOrganizationCustomers} from "../common/api/WebApi";
import Meta from "../common/Meta";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import {useAccess} from "../../lib/AccessProvider";
import ExtendedBootyPagination from "../common/extendedBootyPagination";
import FileSelector from "../calendarUI/FilterSelector";

export default function OrganizationCustomersReport(props) {

  const [context, setContext] = useContext(AppContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);

  const [totalRecords, setTotalRecords] = useState(0);
  const [totalFiltered, setTotalFiltered] = useState(0);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);

  const [render, setRender] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState(searchParams.get('q') || '');
  const [searchIndex, setSearchIndex] = useState(1);

  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || (getCookie('ORG_CUSTOMERS_SORT_DIR') || 'asc'));
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || (getCookie('ORG_CUSTOMERS_SORT') || 1));
  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);
  const [searchDeleted, setSearchDeleted] = useState(searchParams.get('searchDeleted') || false);

  const [searchResults, setSearchResults] = useState([]);
  const [tmpResults, setTmpResults] = useState({});

  const rowsOptions = [10, 50, 100, 500];
  const rowOption = 50;
  const [pageSize, setPageSize] = useState(searchParams.get('pageSize') || getCookie('ORG_CUSTOMERS_ROW') ||  rowOption);

  const [companyTypes, setCompanyTypes] = useState([]);
  const [companyTypeFilter, setCompanyTypeFilter] = useState([]);

  useEffect(()=> {
    setSortOrder(1);
    setSortDir("asc");
    setCookie('ORG_CUSTOMERS_SORT_DIR', "asc");
    setCookie('ORG_CUSTOMERS_SORT', 1);
    setTimeout(() => {
      setRender(render + 1);
      setLoading(true);
    }, 100);
  },[companyTypeFilter]);

  const toCompanyOrgFilterType = (org) => {
    return {
      id : org.companyId,
      name: org.organizationName,
    }
  }

  useEffect(() => {
    let result = tmpResults;

    if ((result?.searchIndex + 1) === (getSearchIndex() + 1)) {

      if (result.error) {
        // todo: handle error
      } else {
        setSearchResults(result?.customers.results);
        setTotalRecords(result?.customers.total - result?.customers.recordsFiltered);
        setTotalFiltered(result?.customers.recordsFiltered);
        setLoading(false);
        setFirstLoad(false);
      }
    }
  }, [tmpResults]);

  const _columns = [
    {
      name: <span className='th'>Name</span>,
      id: 1,
      selector: row => row.guid,
      cell: row => {
        let link = '/client/' + row.guid;
        let member = {
          activeMember : row.active_member,
          flagged: row.flagged
        }
        return <><ActiveMember client={member}/><Link href={link}
                                                   className="link">{row.first_name} {row.last_name}</Link></>;
      },
      sortable: true,
    },

    {
      name: <span className='th'>Home Location</span>,
      id: 15,
      omit: companyContext?.company?.orgChart ? false : true,
      selector: row => row.company_name,
      cell: row => {
        return row?.company_name;
      },
      sortable: true,
    },

    {
      name: <span className='th'>Created On</span>,
      id: 2,
      selector: row => row.create_date,
      cell: row => {
        return row?.create_date ? formatDateTime(row.create_date) : 'None';
      },
      sortable: true,
    },
    {
      name: <span className='th'>Last Visit</span>,
      id: 3,
      selector: row => row.last_visit_date,
      cell: row => {
        return row?.last_visit_date ? formatDateTime(row.last_visit_date) : 'None';
      },
      sortable: true,
    },
    {
      name: <span className='th'>Email</span>,
      id: 14,
      selector: row => row.email,
      cell: row => {
        return row?.email || '';
      },
      sortable: true,
    },
    {
      name: <span className='th'>Referral</span>,
      id: 12,
      selector: row => (row.referral_type_name?.toUpperCase() || -1),
      cell: row => {
        return row?.referral_type_name || 'None';
      },
      sortable: true,
    },
    {
      name: <span className='th' style={{
        width:'60px',
      }}>Flagged</span>,
      id: 13,
      selector: row => (row.flagged),
      cell: row => {
        return row?.flagged ? <><span className={'fa fa-flag'}></span></> : <></>
      },
      sortable: true,
    },
  ];

  const [columns, setColumns] = useState(null);
  const [orgAccess, setOrgAccess] = useState(null);

  const {getAccess} = useAccess();
  useEffect(() => {
    let access = getAccess();
    setOrgAccess(access);

    let _companyTypes = [];
    let orgChart = access?.orgChart;
    if (orgChart?.parentOrganization != null) {
      _companyTypes.push(toCompanyOrgFilterType(orgChart?.parentOrganization));
    } else {
      _companyTypes.push({
        id: context?.sessionUser?.company?.companyId,
        name: context?.sessionUser?.company?.companyName
      })
    }
    for (let j in orgChart?.childOrganizations) {
      _companyTypes.push(toCompanyOrgFilterType(orgChart?.childOrganizations[j]));
    }
    for (let j in orgChart?.siblingOrganizations) {
      _companyTypes.push(toCompanyOrgFilterType(orgChart?.siblingOrganizations[j]));
    }

    setCompanyTypes(_companyTypes);

    for (let j of context?.sessionUser?.companyLinkAccess) {

      let title = null;

      if (j === context?.sessionUser?.company?.companyId) {
        title = context?.sessionUser?.company?.companyName;
      } else {
        for (let k in orgChart?.childOrganizations) {
          if (j === orgChart?.childOrganizations[k].companyId) {
            title = orgChart?.childOrganizations[k].organizationName
          }
        }
        if (orgChart?.parentOrganization != null) {
          if (j === orgChart?.parentOrganization.companyId) {
            title = orgChart?.parentOrganization.organizationName
          }
        }
        if (!title) {
          for (let k in orgChart?.siblingOrganizations) {
            if (j === orgChart?.siblingOrganizations[k].companyId) {
              title = orgChart?.siblingOrganizations[k].organizationName
            }
          }
        }
      }

        let rr = {
          name: <span className='th'>{title}</span>,
          id: 1000 + j,
          right: true,
          omit: !(companyTypeFilter == null || companyTypeFilter.length === 0 || companyTypeFilter.indexOf(j) > -1),
          selector: row => row['reservation_count_' + j],
          cell: row => {
            return row['reservation_count_' + j];
          },
          sortable: true,
        }
        _columns.push(rr)

    }

    _columns.push({
      name: <span className='th'>Action</span>,
      id: 5,
      right: true,
      selector: row => row.guid,
      cell: row => {
        return viewClientFn(row);
      },
      sortable: false,
    })

    setColumns(_columns);

  }, [companyTypeFilter]);

  const viewClientFn = (row) => {
    let link = '/client/' + row.guid;
    return <MDButton variant="gradient" color="info" onClick={() => {
      props.action(row);
    }} size="small">{props?.actionLabel || 'View'}</MDButton>
  }


  const handleSort = (column, sortDirection) => {

    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('ORG_CUSTOMERS_SORT', column.id);
    setCookie('ORG_CUSTOMERS_SORT_DIR', sortDirection);

    setRender(render + 1);
    setLoading(true);
  };

  const handlePageChange = (selector, page) => {
    setStartPage(selector - 1);
    setRender(render + 1);
    setLoading(true);
  };

  const handleRowsPerPageChange = (selector, page) => {
    setStartPage(0);
    setPageSize(selector)
    setRender(render + 1);
    setLoading(true);
    setCookie('ORG_CUSTOMERS_ROW', selector);
  };

  const getSearchIndex = () => {
    return searchIndex;
  }

  const searchCustomersFn = async () => {
    const searchParams = {
      sortDir: sortDir,
      searchCriteria: searchCriteria,
      sortOrder: sortOrder,
      pageSize: pageSize,
      searchIds: companyTypeFilter,
      startPage: startPage,
      searchDeleted: searchDeleted
    }

    let idx = searchIndex + 1;
    setSearchIndex(idx);

    let result = await searchOrganizationCustomers(searchParams, idx);

    setTmpResults(result);

  };

  useEffect(() => {
    const timeOutId = setTimeout(() =>
      searchCustomersFn(), firstLoad ? 1 : 500);
    return () => clearTimeout(timeOutId);
  }, [searchCriteria]);


  const handleSearchChange = (e) => {
    setLoading(true);
    setSearchCriteria(e.target.value);
  }

  useEffect(() => {
    if (render === 0) {
      return;
    }
    searchCustomersFn();
  }, [render]);


  return (
    <DashboardLayout>

      <Meta pageTitle={'Organization Customers'}/>

      <ContextSearchNavbar title="Organization Customers"/>

      <MDBox py={3}>
        <MDBox mb={3}>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <>

                  <MDBox py={1}>

                    <FileSelector
                      types={companyTypes}
                      typeFilter={companyTypeFilter}
                      filterLabel={'Organization Locations'}
                      setFilter={(filters) => {
                        setCompanyTypeFilter(filters)
                      }}
                    />


                    {firstLoad && <>
                      <Loading/>
                    </>
                    }

                    {!firstLoad && columns?.length > 0 && <DataTable
                      disabled={loading}
                      striped
                      columns={columns}
                      keyField={'guid'}
                      data={searchResults}
                      onSort={handleSort}
                      sortServer
                      highlightOnHover
                      pagination
                      paginationServer
                      paginationPerPage={pageSize}
                      paginationComponent={ExtendedBootyPagination}
                      paginationTotalRows={totalRecords}
                      totalFiltered={totalFiltered}
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handleRowsPerPageChange}
                      paginationRowsPerPageOptions={rowsOptions}
                      defaultSortFieldId={getCookie('ORG_CUSTOMERS_SORT') || 1}
                      defaultSortAsc={getCookie('ORG_CUSTOMERS_SORT_DIR') === 'desc' ? false : true}
                      paginationComponentOptions={PaginationOptions}
                    />}

                  </MDBox>
                </>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>

  );
}